/*
 * Copyright (c) 2026 Ambits Technologies LLC. All rights reserved.
 *
 * This source code is the proprietary and confidential property of
 * Ambits Technologies LLC. Unauthorized copying, modification, distribution,
 * or use of this software, via any medium, is strictly prohibited.
 *
 * MyAmbits - AI-Powered Location Safety & Social Platform
 * https://myambits.com
 */

export const TRACK_LINK_BASE = "https://myambits.com/track";

// Mirrors the validator at TrackingPage.tsx: wmh_{timestamp}_{4-10 alphanumeric}.
export const TRACK_PATH_REGEX = /\/track\/(wmh_\d+_[a-z0-9]{4,10})(?:[/?#].*)?$/;

// Build 89 B1a — user reported an SMS containing
// `capacitor://localhost/track/wmh_...`. The code path that produces shareLink
// always routes through this function and TRACK_LINK_BASE is the only string
// that determines the prefix, but the failure mode is severe enough (broken
// link in a SAFETY-CRITICAL flow) that a runtime invariant is worth the cost.
// If a future change ever swaps TRACK_LINK_BASE to a non-https value, this
// fires immediately during the first share rather than silently shipping.
if (!TRACK_LINK_BASE.startsWith("https://")) {
  throw new Error(
    `[trackLink] TRACK_LINK_BASE must start with https:// — got "${TRACK_LINK_BASE}". ` +
      "Universal Links require a public HTTPS origin so the link works whether " +
      "or not the recipient has MyAmbits installed.",
  );
}

export function buildTrackLink(sessionId: string): string {
  return `${TRACK_LINK_BASE}/${sessionId}`;
}

/**
 * Pulls the session id out of a tracking URL or in-app path. Accepts the
 * universal-link form `https://myambits.com/track/<id>`, the www variant,
 * and bare `/track/<id>` paths. Returns null when no valid id is present.
 */
export function parseTrackSessionId(
  url: string | null | undefined,
): string | null {
  if (!url) return null;
  const match = url.match(TRACK_PATH_REGEX);
  return match ? match[1] : null;
}
